module.exports = "https://health.dajiuxing.com.cn/img/assets/img/cashIcon.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fimg%2FcashIcon.png
// module id = HF0r
// module chunks = 93